export function RoutedThroughContactForm(): JSX.Element {
  return <>Contact form</>;
}
